import React, { useEffect, useState } from 'react';
import axios from 'axios';
//import Chart from 'react-apexcharts';

function App() {

  const [orderData, setOrderData] = useState('');
    const [error, setError] = useState('');
    const [months, setMonths] = useState([]);
    const [allMonths, setAllMonths] = useState([]);
    const [orderCounts, setOrderCounts] = useState([0, 0, 0, 0, 0]);
    const [totalOrderCounts, setTotalOrderCounts] = useState(0);

    const getOrderDetails = async () => {
        try{
          const response = await axios.get('https://demo.sninfoserv.com/api/orders/all-orders/');
          //console.log(response.data);
          if(response.data.status === 'success'){
            setOrderData(response.data.orderData);
            setTotalOrderCounts(response.data.orderData.length);
          }
        }catch (error) {
        setError({ error: error.message });
        }
    };

    useEffect(() => {
        getOrderDetails();
    },[]);

    
    const getRandomNumber = () => {
      return Math.floor(Math.random() * 3) + 1;
    };
    

    const getMonthStartEnd = (inputDate) => {
      const date = new Date(inputDate);
      const year = date.getFullYear();
      const month = date.getMonth();
  
      const startDate = new Date(year, month, 1);
      const endDate = new Date(year, month + 1, +1);
  
      return {
          start: startDate.toISOString().split('T')[0],
          end: endDate.toISOString().split('T')[0],
      };
    };
  

  //const result = getMonthStartEnd('2024-11-01');
  //console.log(result);


    useEffect(() => {
      const getCurrentAndPreviousMonths = () => {
        const monthsArray = [];
        const currentDate = new Date();

        // Push the current month
        monthsArray.push(currentDate.toISOString().split('T')[0]);

        // Get the previous 5 months
        for (let i = 0; i <= 3; i++) {
            const previousDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
            monthsArray.push(previousDate.toISOString().split('T')[0]);
        }
        return monthsArray;
      };

      setMonths(getCurrentAndPreviousMonths());
    }, []);

    const addOrders = (index, newOrders) => {
      setOrderCounts(prevCounts => {
          const updatedCounts = [...prevCounts]; // Create a copy of the current counts
          updatedCounts[index] = newOrders*(totalOrderCounts/100); // Add new orders to the specified index
          return updatedCounts; // Return the updated counts
      });
    };

    useEffect(()=>{

      months && months.map((month, index) => {
        const dates = getMonthStartEnd(month);

      const orderCount = orderData && orderData.filter(orders=>{ 
        const itemDate = new Date(orders.date);
    
        const startDateObj = dates.start ? new Date(dates.start) : null;
        if (startDateObj) {
          startDateObj.setHours(0, 0, 0, 0); 
        }
        const endDateObj = dates.end ? new Date(dates.end) : null;
        if (endDateObj) {
          endDateObj.setHours(23, 59, 59, 999); 
        }

        return(
          (startDateObj ? itemDate >= startDateObj : true) && 
          (endDateObj ? itemDate <= endDateObj : true) 
        );
      });

      addOrders(index, orderCount.length);

    });

    },[months, orderData]);
  

    const options = {
      chart: {
        type: 'donut',
      },
      labels: ['A', 'B', 'C', 'D', 'E'],
    };

    const series = orderCounts;

    console.log(orderCounts);
 
  return (
   
    
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-8 d-flex align-items-strech">
              <div class="card w-100">
                <div class="card-body">
                  <div class="d-sm-flex d-block align-items-center justify-content-between mb-9">
                    <div class="mb-3 mb-sm-0">
                      <h5 class="card-title fw-semibold">Revenue Forecast</h5>
                    </div>
                    <div>
                      <select class="form-select">
                        <option value="1">March 2024</option>
                        <option value="2">April 2024</option>
                        <option value="3">May 2024</option>
                        <option value="4">June 2024</option>
                      </select>
                    </div>
                  </div>
                  <div id="revenue-forecast"></div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="row">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center gap-6 mb-4 pb-3">
                        <span
                          class="round-48 d-flex align-items-center justify-content-center rounded bg-secondary-subtle">
                          <iconify-icon icon="solar:football-outline" class="fs-6 text-secondary"> </iconify-icon>
                        </span>
                        <h6 class="mb-0 fs-4">New Customers</h6>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mb-6">
                        <h6 class="mb-0 fw-medium">New goals</h6>
                        <h6 class="mb-0 fw-medium">83%</h6>
                      </div>
                      <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25"
                        aria-valuemin="0" aria-valuemax="100" style={{height: '7px'}}>
                        <div class="progress-bar bg-secondary" style={{width: '83%'}}></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center gap-6 mb-4">
                        <span
                          class="round-48 d-flex align-items-center justify-content-center rounded bg-danger-subtle">
                          <iconify-icon icon="solar:box-linear" class="fs-6 text-danger"></iconify-icon>
                        </span>
                        <h6 class="mb-0 fs-4">Total Income</h6>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <h4>$680</h4>
                          <span class="fs-11 text-success fw-semibold">+18%</span>
                        </div>
                        <div class="col-12">
                        {/* <Chart options={options} series={series} type="donut" height={350} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 d-flex align-items-stretch">
              <div class="card w-100">
                <div class="card-body p-4">
                  <h5 class="card-title fw-semibold mb-4">Recent Orders</h5>
                  <div class="table-responsive" data-simplebar>
                    <table class="table text-nowrap align-middle table-custom mb-0">
                      <thead>
                        <tr>
                          <th scope="col" class="text-dark fw-normal ps-0">Customer</th>
                          <th scope="col" class="text-dark fw-normal">Date</th>
                          <th scope="col" class="text-dark fw-normal">Items</th>
                          <th scope="col" class="text-dark fw-normal">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                      {orderData && orderData.slice().reverse().slice(-5).map((orders, index) =>
                        <tr>
                          <td class="ps-0">
                            <div class="d-flex align-items-center gap-6">
                              <img src={`assets/images/profile/user-${getRandomNumber()}.jpg`} alt={orders.billingData.fName} width="48"
                                class="rounded" />
                              <div>
                                <h6 class="mb-0">{orders.billingData.fName} {orders.billingData.lName}</h6>
                                <span>{orders.billingData.email}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span>{orders.date}</span>
                          </td>
                          <td>
                            <span class="badge bg-success-subtle text-success">{orders.Items}</span>
                          </td>
                          <td>
                            <span class="text-dark">₹ {Number(orders.grandTotal).toFixed(2)}</span>
                          </td>
                        </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 d-flex align-items-stretch">
              <div class="card w-100">
                <div class="card-body p-4">
                  <div class="mb-4">
                    <h5 class="card-title fw-semibold">Daily activities</h5>
                  </div>
                  <ul class="timeline-widget mb-0 position-relative mb-n5">
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n1 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-primary flex-shrink-0 mt-2"></span>
                        <span class="timeline-badge-border d-block flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n1">Payment received from John
                        Doe of $385.90</div>
                    </li>
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n6 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-warning flex-shrink-0"></span>
                        <span class="timeline-badge-border d-block flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n6 fw-semibold">New sale
                        recorded <a href="javascript:void(0)" class="text-primary d-block fw-normal ">#ML-3467</a>
                      </div>
                    </li>
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n6 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-warning flex-shrink-0"></span>
                        <span class="timeline-badge-border d-block flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n6">Payment was made of $64.95
                        to Michael</div>
                    </li>
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n6 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-secondary flex-shrink-0"></span>
                        <span class="timeline-badge-border d-block flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n6 fw-semibold">New sale
                        recorded <a href="javascript:void(0)" class="text-primary d-block fw-normal ">#ML-3467</a>
                      </div>
                    </li>
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n6 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-danger flex-shrink-0"></span>
                        <span class="timeline-badge-border d-block flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n6 fw-semibold">Project meeting
                      </div>
                    </li>
                    <li class="timeline-item d-flex position-relative overflow-hidden">
                      <div class="timeline-time mt-n6 text-muted flex-shrink-0 text-end">09:46
                      </div>
                      <div class="timeline-badge-wrap d-flex flex-column align-items-center">
                        <span class="timeline-badge bg-primary flex-shrink-0"></span>
                      </div>
                      <div class="timeline-desc fs-3 text-dark mt-n6">Payment received from John
                        Doe of $385.90</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          
		  
		  
		  
          <div class="py-6 px-6 text-center">
              <p class="mb-0 fs-4">Design and Developed by <a href="mailto:bizzoters@gmail.com" target="_blank"
                class="pe-1 text-primary text-decoration-underline">Bizzoters</a></p>
          </div>
		  
		  
        </div>
		
   
  );
}

export default App;
